"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSpecialType = void 0;
var React = require("react");
var Modal = require("react-modal");
require("./SelectSpecialType.scss");
var FormComponent_1 = require("../_shared/components/inputs/FormComponent");
var classnames_1 = require("classnames");
var SpecialTypeInput_1 = require("../_shared/components/SpecialTypeInput");
var _ = require("lodash");
var MAX_TEXTAREA_LENGTH = 100;
var SelectSpecialType = /** @class */ (function (_super) {
    __extends(SelectSpecialType, _super);
    function SelectSpecialType(newProps) {
        var _this = _super.call(this, newProps) || this;
        _this.state = _this.initialState();
        Modal.setAppElement('#application'); // Avoid readers to read behind it. May set in other place
        return _this;
    }
    SelectSpecialType.prototype.selectButtonPressed = function () {
        var _a = this.state, specialType = _a.specialType, description = _a.description;
        if (!specialType) {
            return;
        }
        this.props.onSpecialTypeSelected(specialType, description);
        this.props.onClose();
        this.setState(this.initialState());
    };
    SelectSpecialType.prototype.componentWillReceiveProps = function (newProps) {
        if (!_.isEqual(newProps.selectedSpecialType, this.props.selectedSpecialType)) {
            var specialTypeCode_1 = _.get(newProps.selectedSpecialType, 'specialType.code', -1);
            var specialType = newProps.specialTypes.find(function (specialTypes) { return specialTypes.code.toString() === specialTypeCode_1.toString(); }) || null;
            var description = _.get(newProps.selectedSpecialType, 'description', '');
            this.setState({ specialType: specialType, description: description });
        }
    };
    SelectSpecialType.prototype.initialState = function () {
        var specialTypeCode = _.get(this.props.selectedSpecialType, 'specialType.code', -1);
        var specialType = this.props.specialTypes.find(function (specialTypes) { return specialTypes.code === specialTypeCode; }) || null;
        var description = _.get(this.props.selectedSpecialType, 'description', '');
        return { specialType: specialType, description: description };
    };
    SelectSpecialType.prototype.render = function () {
        var _this = this;
        var subTypeCode = this.state.specialType ? this.state.specialType.code : '';
        var selectButtonStyles = (0, classnames_1.default)({
            'button': true,
            'button-disabled': subTypeCode === '',
        });
        return (React.createElement(Modal, { isOpen: this.props.open, className: "select-special-modal" },
            React.createElement("div", { id: "select-special-type", className: "column" },
                React.createElement("h1", null, " Selecteer Speciaal Type "),
                React.createElement("div", { className: "margin-8" }),
                React.createElement("div", { className: "form column" },
                    React.createElement("div", { className: "type-select-group row" },
                        React.createElement("span", null, "Soort:"),
                        React.createElement("div", { className: "margin-4" }),
                        React.createElement(SpecialTypeInput_1.default, { specialSubtypes: this.props.specialTypes, subTypeCode: subTypeCode.toString(), onSubTypeChanged: function (specialType) { return _this.setState({ specialType: specialType }); } })),
                    React.createElement("div", { className: "margin-8" }),
                    React.createElement("div", { className: "description-group column" },
                        React.createElement("span", null, "Omschrijving:"),
                        React.createElement("textarea", { name: "description", onChange: function (event) { return _this.handleInputChange(event); }, value: this.state.description, rows: 6, maxLength: MAX_TEXTAREA_LENGTH })),
                    React.createElement("div", { className: "margin-16" }),
                    React.createElement("div", { className: "buttons-container row" },
                        React.createElement("span", { className: selectButtonStyles, onClick: function () {
                                _this.selectButtonPressed();
                            } }, "Toevoegen "),
                        React.createElement("div", { className: "margin-8" }),
                        React.createElement("span", { className: "button", onClick: function () {
                                _this.props.onClose();
                            } }, "Annuleer "))))));
    };
    return SelectSpecialType;
}(FormComponent_1.default));
exports.SelectSpecialType = SelectSpecialType;
